var uploadProgressPercent = 0;
var uploadType;

function updateUploadProgress ($progressCard) {
    uploadProgressPercent++;
    $progressCard.find('span.upload-progress').css('width', uploadProgressPercent+"%");
}

function uploadFile(event, fileName) {

    var result = event.target.result;

    //$.post('upload.php', { data: result, name: fileName }, updateUploadProgress);
}

function uploadDone(uploadType) {

  $uploadProgressCard.addClass('d-none');

  $('.card-file-uploaded.card-file-'+uploadType+'.d-none').removeClass('d-none');

  $fileInputBox.attr('disabled', false);

  if($('.reference-upload-files').length) {
    $('.card.card-file.card-file-uploaded')
      .first()
      .clone()
      .removeClass('card-file-'+uploadType)
      .insertAfter($('.card-file-in-progress'))
      .addClass('d-none')
      .find('.file-name')
      .text('');

    $('.card.card-file.card-file-uploaded.d-none')
      .find('.file-size')
      .text('');

  }
  setupDeleteButtons();
}

$(document).ready(function() {

  $fileInputBox = $(".custom-file-input");
  $uploadProgressCard = $('.card-file-in-progress');
  $hiddenDocCard = $('.card-file-uploaded.card-file-doc.d-none');

  function readURL(input, fileName) {

      if (input.files && input.files[0]) {

        $uploadProgressCard.removeClass('d-none');

        if(!$('fieldset.reference-upload').length) {
          $(".card-file-with-input-wrapper").addClass('d-none');
        } else {
          $fileInputBox.attr('disabled', true);
        }

        var ext = fileName.split('.').pop();

        var reader = new FileReader();

        reader.readAsDataURL(input.files[0]);

        reader.onload = function (e) {

          if (ext=="jpg" || ext=="jpeg" || ext=="png" || ext=="gif" || ext=="svg") {

            if($('.file-upload-image.active')) {
              $('.file-upload-image.active')
                .css('background-image', 'url('+e.target.result+')')
                .css('background-size', 'cover')
                .addClass('full')
                .find('img')
                .attr('src', e.target.result);
            }

            uploadType = "image";

          } else {

            var fileSize = (input.files[0].size/1024/1024).toFixed(2);
            $('.card-file-uploaded.d-none .file-size').text(fileSize);

            uploadType = "doc";

          }

          fileName = fileName.replace(/.*[\/\\]/, '');
          $uploadProgressCard.find('.file-name').text("Uploading "+fileName);
          //console.log(uploadType);

          $('.card-file-uploaded.d-none')
            .addClass('card-file-'+uploadType)
            .find('.file-name')
            .text(fileName);

          uploadFile(e, fileName);

        }

        reader.onprogress = function(e) {
          updateUploadProgress($uploadProgressCard);
        };

        reader.onloadend = function(e) {
          uploadDone(uploadType);
        };

      }
    }

    $fileInputBox.change(function() {
        readURL(this, this.value);
    });

    $('.file-upload-image.active').on('click', function() {
      $fileInputBox.click();
    });

});
